var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Delete_icon",
    "data-name": "Delete icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.377,
    height: 25.915,
    viewBox: "0 0 19.377 25.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1969",
    "data-name": "Rectangle 1969",
    width: 19.377,
    height: 25.915,
    fill: "#3c3c3b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete_icon-2",
    "data-name": "Delete icon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9500",
    "data-name": "Path 9500",
    d: "M22.882,44.531H6.58a.624.624,0,0,0-.623.67L7.151,61.525a2.34,2.34,0,0,0,2.33,2.13h10.5a2.339,2.339,0,0,0,2.33-2.13L23.505,45.2a.624.624,0,0,0-.623-.67m-12.365,16.4H10.5a.574.574,0,0,1-.573-.555L9.5,47a.574.574,0,0,1,1.147-.037l.429,13.374a.574.574,0,0,1-.555.592m4.788-.573a.574.574,0,0,1-1.148,0V46.986a.574.574,0,1,1,1.148,0Zm4.232.016a.574.574,0,0,1-.573.557h-.017a.574.574,0,0,1-.557-.59l.383-13.374A.574.574,0,0,1,19.92,47Z",
    transform: "translate(-5.048 -37.74)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9501",
    "data-name": "Path 9501",
    d: "M17.636,2.949h-2.62V2.415A2.418,2.418,0,0,0,12.6,0h-5.6A2.418,2.418,0,0,0,4.591,2.415v.534H1.742A1.742,1.742,0,0,0,0,4.69v.328a.624.624,0,0,0,.624.624H18.753a.625.625,0,0,0,.624-.624V4.69a1.742,1.742,0,0,0-1.742-1.742m-4.055,0H6.026V2.415a.981.981,0,0,1,.98-.98h5.6a.982.982,0,0,1,.98.98Z",
    fill: "#3c3c3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/Delete icon.66494f6f98069fb5bad5c357e54c5924.svg";
export { ForwardRef as ReactComponent };